/**
 * 店務 P&L／現金（Overseas patch 255）
 */
export const STORE_PNL_MENU_IDS = {
  group: 990460,
  desk: 990461,
  view: 990462,
  gate: 990463
}

export default STORE_PNL_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storePnL.js